export function OperationsIcon({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18 12C20.2091 12 22 10.2091 22 8C22 5.79086 20.2091 4 18 4C15.7909 4 14 5.79086 14 8C14 10.2091 15.7909 12 18 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 32C12.2091 32 14 30.2091 14 28C14 25.7909 12.2091 24 10 24C7.79086 24 6 25.7909 6 28C6 30.2091 7.79086 32 10 32Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26 32C28.2091 32 30 30.2091 30 28C30 25.7909 28.2091 24 26 24C23.7909 24 22 25.7909 22 28C22 30.2091 23.7909 32 26 32Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18 12V18M10 24V18H26V24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
